import { gql } from '@apollo/client';

// Study queries
export const GET_STUDIES_QUERY = gql`
  query GetStudies($limit: Int = 100, $offset: Int = 0) {
    studies(limit: $limit, offset: $offset) {
      edges {
        id
        protocolId
        name
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const GET_STUDY_QUERY = gql`
  query GetStudy($id: UUID!) {
    study(id: $id) {
      id
      protocolId
      name
      status
      protocolAliases {
        id
        studyId
        protocolId
        aliasType
        isPrimary
      }
      createdAt
      updatedAt
    }
  }
`;

// Search studies query
export const SEARCH_STUDIES_QUERY = gql`
  query SearchStudies($query: String!, $limit: Int = 10) {
    searchStudies(query: $query, limit: $limit) {
      id
      protocolId
      name
      protocolAliases {
        protocolId
        isPrimary
      }
      createdAt
      updatedAt
    }
  }
`;

// Accessible organizations query
export const ACCESSIBLE_ORGANIZATIONS_QUERY = gql`
  query AccessibleOrganizations($limit: Int = 100, $offset: Int = 0, $search: String) {
    accessibleOrganizations(limit: $limit, offset: $offset, search: $search) {
      edges {
        id
        name
        domain
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// Study site organizations query (for activity creation + context enrichment)
export const STUDY_SITE_ORGANIZATIONS_QUERY = gql`
  query StudySiteOrganizations($studyId: UUID!) {
    studySiteOrganizations(studyId: $studyId) {
      id
      name
      domain
      principalInvestigator
      ctmsSystem
      paymentSystems
      senderAddress
      refreshCadence
      lastCtmsPull
      lastVivaPull
      lastGpsPull
      ctaEffectiveDate
      firstPatientVisitDate
      screeningCount
      randomizedCount
      screenFailedCount
    }
  }
`;

// Study sponsor query (for remittance creation)
export const STUDY_SPONSOR_QUERY = gql`
  query StudySponsor($studyId: UUID!) {
    studySponsor(studyId: $studyId) {
      studyId
      sponsorOrganizationId
      sponsorName
    }
  }
`;

// Study-site pairs query
export const GET_STUDY_SITE_PAIRS_QUERY = gql`
  query GetStudySitePairs($limit: Int = 100, $offset: Int = 0, $search: String) {
    studySitePairs(limit: $limit, offset: $offset, search: $search) {
      edges {
        studyId
        protocolId
        studyName
        primaryProtocolAlias
        siteOrganizationId
        siteName
        siteDomain
        principalInvestigatorNames
      }
      totalCount
    }
  }
`;
